export default __webpack_public_path__ + "static/wowawards-41dcdccf0e78a6c2eab9613be4837107.png";